document.addEventListener('DOMContentLoaded', () => {
  // ----- Main Slider (with arrows) -----
  function setCenterItem(row) {
    const items = Array.from(row.querySelectorAll('.custom-homepage__slider-item'));
    if (items.length === 0) return;
    
    if (window.innerWidth >= 992) {
      items.forEach(item => item.classList.remove('custom-homepage__slider-item--center'));
      return;
    }
    
    const midIndex = Math.floor(items.length / 2);
    items.forEach(item => item.classList.remove('custom-homepage__slider-item--center'));
    items[midIndex].classList.add('custom-homepage__slider-item--center');
  }

  function nextSlide(row) {
    const first = row.firstElementChild;
    if (first) {
      row.appendChild(first);
    }
    setCenterItem(row);
  }

  function prevSlide(row) {
    const last = row.lastElementChild;
    if (last) {
      row.insertBefore(last, row.firstElementChild);
    }
    setCenterItem(row);
  }

  document.querySelectorAll('.custom-homepage__slider-wrapper').forEach(wrapper => {
    const row = wrapper.querySelector('.custom-homepage__slider-row');
    const btnLeft = wrapper.querySelector('.custom-homepage__slider-arrow--left');
    const btnRight = wrapper.querySelector('.custom-homepage__slider-arrow--right');
    if (!row || !btnLeft || !btnRight) return;
    setCenterItem(row);
    btnRight.addEventListener('click', () => nextSlide(row));
    btnLeft.addEventListener('click', () => prevSlide(row));
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.custom-homepage__slider-wrapper').forEach(wrapper => {
      const row = wrapper.querySelector('.custom-homepage__slider-row');
      if (row) {
        setCenterItem(row);
      }
    });
  });

  // ----- Collapsible content toggle logic -----
  document.querySelectorAll('.collapsible-content').forEach(contentEl => {
    const btn = contentEl.parentElement.querySelector('.toggle-content-btn');
    if (!btn) return;

    btn.addEventListener('click', () => {
      if (contentEl.classList.contains('collapsed')) {
        // Expand
        contentEl.classList.remove('collapsed');
        btn.remove();
      }
    });
  });
  
});